import { Route, Navigate } from 'react-router-dom';
import { authRoute, lazyPage } from './routeHelpers';

const MallRoutes = lazyPage(() => import('../pages/mall'));
const ProfilePage = lazyPage(() => import('../pages/ProfilePage'));
const MyWorkTasksPage = lazyPage(() => import('../pages/my-work-tasks/MyWorkTasksPage'));
const MyDailyReportsPage = lazyPage(() => import('../pages/my-daily-reports/MyDailyReportsPage'));
export function getMallAndProfileRoutes(isAuthenticated) {
  return (
    <>
      <Route path="/mall/*" element={authRoute(isAuthenticated, <MallRoutes />)} />

      <Route path="/profile/*" element={authRoute(isAuthenticated, <ProfilePage />)} />

      <Route path="/my-work-tasks" element={authRoute(isAuthenticated, <MyWorkTasksPage />)} />

      <Route path="/my-daily-reports" element={authRoute(isAuthenticated, <MyDailyReportsPage />)} />

      <Route path="/membership" element={authRoute(isAuthenticated, <Navigate to="/profile/account-settings" />)} />
    </>
  );
}
